import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CONFIG_TOKEN } from '@core/tokens';

import { UserPreferences } from './user-preferences.models';

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesService {
  readonly #ROOT_URL = inject(CONFIG_TOKEN).backendRootUrl;
  readonly #httpClient = inject(HttpClient);

  public getUserPreferences$(): Observable<UserPreferences> {
    return this.#httpClient.get<UserPreferences>(`${this.#ROOT_URL}/api/v1/users/preferences`);
  }

  public saveUserPreferences$(preferences: UserPreferences): Observable<UserPreferences> {
    return this.#httpClient.post<UserPreferences>(`${this.#ROOT_URL}/api/v1/users/preferences`, preferences);
  }
}
